import { MenuData } from '../types';

export const menuItems: MenuData = {
  appetizers: [
    { 
      name: "Chicken Tikka Tacos", 
      description: "Tender chicken tikka served in soft tortillas with fresh cilantro, onions, and tangy mint chutney - a perfect fusion of Indian spices and Mexican comfort." 
    },
    { 
      name: "Chicken 65", 
      description: "Crispy fried chicken marinated in yogurt, ginger-garlic, and fiery spices, tempered with curry leaves and green chilies." 
    },
    { 
      name: "Hyderabadi Chilli Chicken", 
      description: "Crispy chicken tossed with peppers, green chilies, and spicy Indo-Chinese sauces — a Hyderabadi favorite with bold, fiery flavor." 
    },
    { 
      name: "Hyderabadi Achaari Chicken", 
      description: "Tender chicken cooked in tangy, pickle-spiced masala — bursting with authentic Hyderabadi zest and smoky flavors." 
    },
    { 
      name: "Hyderabadi Chicken 65 Burger", 
      description: "Crispy, fiery Chicken 65 paired with tangy slaw and bold Zaikedaar Sauce, served in our house-made brioche bun — Hyderabadi fusion at its best." 
    },
    { 
      name: "Hyderabadi Chicken Shawarma", 
      description: "Juicy marinated chicken wrapped in pita, layered with veggies, garlic, and our signature Zaikedaar Sauce — a Hyderabadi street-style twist." 
    },
    { 
      name: "Hyderabadi Chicken Sliders", 
      description: "Mini brioche buns filled with spiced Hyderabadi chicken, fresh toppings, and our bold Zaikedaar Sauce — bite-sized fusion packed with flavor." 
    }
  ],
  mains: [
    { 
      name: "Beef Shawarma", 
      description: "Slow-roasted marinated beef with aromatic Middle Eastern spices, served with fresh vegetables and our signature sauce." 
    },
    { 
      name: "Chicken Over Rice", 
      description: "Perfectly seasoned grilled chicken served over fragrant basmati rice with our house-made white and hot sauce." 
    },
    { 
      name: "Double Patty Burger", 
      description: "Two juicy beef patties with melted cheese, fresh lettuce, tomatoes, and our special Urban Zaikha sauce on a brioche bun." 
    },
    { 
      name: "Smash Burger", 
      description: "Crispy-edged smashed beef patty with caramelized onions, pickles, and our signature sauce on a toasted bun." 
    },
    { 
      name: "Hyderabadi Mutton Dum Biryani", 
      description: "Authentic slow-cooked mutton biryani with fragrant basmati rice, saffron, and traditional Hyderabadi spices, cooked to perfection in the traditional dum style." 
    },
    { 
      name: "Hyderabadi Chicken Dum Biryani", 
      description: "Fragrant basmati rice layered with spiced chicken, caramelized onions, saffron, and herbs, slow-cooked in the traditional dum style for rich, authentic Hyderabadi flavor." 
    },
    { 
      name: "Hyderabadi Chicken Korma", 
      description: "Chicken slow-cooked in a rich, creamy yogurt and nut gravy — a royal Hyderabadi delicacy with aromatic spices." 
    },
    { 
      name: "Hyderabadi Mutton Korma", 
      description: "Succulent mutton simmered in velvety yogurt-onion gravy with warming spices — a timeless Hyderabadi specialty." 
    }
  ],
  desserts: [
    { 
      name: "Gajar Ka Halwa", 
      description: "Traditional Indian carrot pudding slow-cooked with milk, ghee, and cardamom, garnished with nuts and served warm." 
    },
    { 
      name: "Hyderabadi Kaddu ki Kheer", 
      description: "Traditional Hyderabadi dessert made with bottle gourd, milk, cardamom, and nuts — creamy, festive, and soul-satisfying." 
    },
    { 
      name: "Hyderabadi Double ka Meetha", 
      description: "Authentic Hyderabadi bread pudding with fried bread, saffron milk, ghee, and nuts — rich, warm, and indulgent." 
    },
    { 
      name: "Hyderabadi Qubani ka Meetha", 
      description: "Slow-cooked apricots served with cream and nuts — a royal Hyderabadi dessert that's tangy, sweet, and decadent." 
    }
  ]
};
